import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[640px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20luxury%20fashion%20boutique%20display%20table%20with%20sneakers%20watches%20bags%20and%20accessories%20arranged%20neatly%20on%20warm%20wooden%20surface%20soft%20natural%20lighting%20editorial%20photography%20high%20detail%20warm%20cream%20tones&width=1600&height=900&seq=hero-unique-2026&orientation=landscape"
          alt="CSSBuy Spreadsheet"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-24 md:py-32 w-full">
        <div className="max-w-3xl">
          <span className="inline-block text-xs md:text-sm font-medium tracking-widest text-white/80 uppercase mb-4">
            {t("hero_eyebrow")}
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            {t("hero_title")}
          </h1>
          <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 max-w-2xl">
            {t("hero_subtitle")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 text-white font-semibold px-6 py-3 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t("hero_cta_primary")}
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#categories"
              className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white font-semibold px-6 py-3 rounded-md border border-white/20 hover:bg-white/20 transition-colors whitespace-nowrap"
            >
              {t("hero_cta_secondary")}
              <i className="ri-arrow-down-line" />
            </a>
          </div>
          <p className="mt-6 text-xs md:text-sm text-white/60">
            {t("hero_trust")}
          </p>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 pb-6">
          <div className="flex flex-wrap gap-2">
            {categories.slice(0, 7).map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center bg-white/10 backdrop-blur-sm text-white text-xs px-3 py-1.5 rounded-full border border-white/20 hover:bg-white/20 transition-colors whitespace-nowrap"
              >
                {cat.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}